import React     from 'react'
import PropTypes from 'prop-types'

import { translateBool                    } from 'alto-utils/lib/utils'
import { AdminForm, AdminTable, AdminPage } from 'alto-react-components/lib/components'
import CanteenRepository, { Course }        from 'alto-react-canteen/lib/models'

# TODO: load groups in main CourseManagement component and pass them down

class CourseTable extends AdminTable
  @contextTypes = { backend: PropTypes.object }

  model: Course
  idColumn: false
  @defaultOrdering: 'orderNumber'

  constructor: (props, context) ->
    super(props, context)

    @state.groups          = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam skupin'

    CanteenRepository.forBackend(context.backend).courseGroups.orderBy('orderNumber').all()
      .then (groups) => @setState({ groups, ready: true })

  columns: ->
    groupOptions = @state.groups.map (group) -> [group.displayName, group.displayName]

    [{
       property: 'orderNumber'
       header:
         label: 'Pořadové číslo'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'contains'
     }, {
       property: 'name'
       header:
         label: 'Identifikátor'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       property: 'displayName'
       header:
         label: 'Název'
         formatters: [@orderableAndFilterable()]
       filter:
         matcher: 'icontains'
     }, {
       _property: 'group.displayName'
       property: (course) -> course.associations.group.displayName
       header:
         label: 'Skupina'
         formatters: [@orderableAndFilterable(type: 'select', options: groupOptions)]
       filter:
         matcher: 'exact'
     }, {
       property: 'isAdditional'
       header:
         label: 'Je doplňkový'
         formatters: [@orderableAndFilterable(type: 'boolean_select')]
       cell:
         formatters: [translateBool]
      filter:
         matcher: 'exact'
     }]

class CourseForm extends AdminForm
  @contextTypes = { backend: PropTypes.object }

  model: Course

  constructor: (props, context) ->
    super(props, context)

    @state.groups          = null
    @state.ready           = false
    @state.notReadyMessage = 'Načítám seznam skupin'

    CanteenRepository.forBackend(context.backend).courseGroups.orderBy('orderNumber').all()
      .then (groups) => @setState({ groups, ready: true })

  inputs: ->
    nameInput = switch @props.action
      when 'create'
        label:     'Identifikátor'
        property:  'name'
        validator: ['notEmpty', /^[a-z0-9_]+$/]
        help:      'Databázový identifikátor, pouze malá písmena, čísla a _'
      when 'update'
        type:     'static'
        label:    'Identifikátor'
        property: 'name'

    [nameInput,
     {
       label:     'Název'
       property:  'displayName'
       validator: 'notEmpty'
     }, {
       label:     'Pořadové číslo'
       property:  'orderNumber'
       type:      'integer'
       validator: 'notEmpty'
     }, {
       type:      'select'
       label:     'Skupina'
       property:  'groupName'
       options:   @state.groups.map (group) -> [group.displayName, group.name]
     }, {
       type:      'checkbox'
       label:     'Je doplňkový'
       property:  'isAdditional'
     }]

export default class CourseManagement extends AdminPage
  @contextTypes = { backend: PropTypes.object }

  tableComponent: CourseTable
  formComponent:  CourseForm

  relation: ->
    @__relation ?= CanteenRepository.forBackend(@context.backend).courses.with('group')
